module.exports = __webpack_public_path__ + "img/quarz-logo.efa53239.png";